import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { messagesAPI } from '../lib/api';
import { t } from '../lib/i18n';
import { panelCls } from './ui';
import { nyTime } from '../lib/nyTime';

const LINKS = [
  { to: '/portal', label: 'Referral center' },
  { to: '/portal/wallet', label: 'Wallet' },
  { to: '/portal/community', label: 'Community' },
  { to: '/portal/messages', label: 'Messages' },
];

function NotificationsBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    messagesAPI.notifications().then(({ data }) => setData(data)).catch(() => {});
  }, []);
  useEffect(() => {
    const onDoc = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next && data.unread) {
      messagesAPI.markRead().then(() => setData((d) => ({ ...d, unread: 0 }))).catch(() => {});
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} aria-label={t('Notifications')}
        className="relative py-2 text-mms-muted hover:text-mms-text">
        <Bell size={17} />
        {data.unread > 0 && (
          <span className="absolute -right-1 -top-0.5 rounded-full bg-mms-accent px-1 text-[10px] font-bold text-mms-accent-ink mms-num">
            {data.unread}
          </span>
        )}
      </button>
      {open && (
        <div className={`${panelCls} absolute right-0 z-40 mt-1 w-80 p-2`}>
          {data.items.length === 0 ? (
            <p className="p-3 text-sm text-mms-muted">{t('No notifications yet.')}</p>
          ) : (
            <ul className="max-h-80 space-y-1 overflow-y-auto text-sm">
              {data.items.map((n) => (
                <li key={n.id} className={`rounded-md p-2 ${n.read ? 'text-mms-muted' : 'bg-mms-raised'}`}>
                  {n.text}
                  <div className="mt-0.5 text-xs text-mms-faint">{nyTime(n.at)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default function PortalHeader({ title }) {
  const { pathname } = useLocation();
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h1 className="text-lg font-semibold">{title}</h1>
      <div className="flex items-center gap-3 text-sm">
        {LINKS.filter((l) => l.to !== pathname).map((l) => (
          <Link key={l.to} to={l.to} className="text-mms-accent underline">{t(l.label)}</Link>
        ))}
        <NotificationsBell />
      </div>
    </div>
  );
}
